import { useContext, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { Avatar, Button, Divider } from '@mui/material';
import { useUserStore } from '@/user/stores/userStore';
import { MenuToggleContext } from '@/base/layouts/contexts/MenuToggleContext';
import LogoutModal from '../../LogoutModal';

import {
  UserMenuContainer,
  UserBoxLabel,
  UserBoxText,
  UserMenuTopWrapper,
  UserMenuHeaderWrapper,
  AvatarWrapper,
  GoBackLink,
  AccountItemText,
  UserMenuBottomWrapper,
  MenuItemsList
} from './UserMenu.styles';
import { UserMenuItems } from '@/common/components/UserMenuItems/UserMenuItems';
import { UserboxDaysLeftWarning } from '../../UserboxDaysLeftWarning/UserboxDaysLeftWarning';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import useAccountStore from '@/user/stores/accountStore';

export const UserMenu = () => {
  const { t } = useTranslation();
  const {
    profile: { email, name, picture }
  } = useUserStore();
  const { goToMain, closeMenu } = useContext(MenuToggleContext);
  const {
    daysTrialEndNumber,
    status,
    plan: { name: planName }
  } = useAccountStore();

  const [isLogOutOpen, setIsLogoutOpen] = useState<boolean>(false);
  const handleOnLogoutOpen = (): void => {
    setIsLogoutOpen(true);
  };

  const renderUserSummary = () => {
    return (
      <UserBoxText>
        <UserBoxLabel variant="body1">{name || email}</UserBoxLabel>
        {status === 'ACTIVE' && <>{planName}</>}
        {status === 'TRIALING' && (
          <UserboxDaysLeftWarning
            daysLeft={daysTrialEndNumber}
            planName="Trial"
          />
        )}
      </UserBoxText>
    );
  };

  return (
    <UserMenuContainer>
      <UserMenuTopWrapper>
        <UserMenuHeaderWrapper>
          <AvatarWrapper>
            <Avatar variant="circular" alt={name} src={picture} />
            {renderUserSummary()}
          </AvatarWrapper>
          <GoBackLink onClick={goToMain}>{t('Go back')}</GoBackLink>
        </UserMenuHeaderWrapper>
        <Divider />

        <MenuItemsList>
          <AccountItemText primary={t('Account')} />
          <UserMenuItems handleCloseMenu={closeMenu} />
        </MenuItemsList>
      </UserMenuTopWrapper>
      <UserMenuBottomWrapper>
        <Divider sx={{ mb: 2.4 }} />
        <Button color="primary" onClick={handleOnLogoutOpen}>
          <LockOpenTwoToneIcon />
          {t('Sign out')}
        </Button>
      </UserMenuBottomWrapper>

      <LogoutModal
        handleClose={closeMenu}
        isLogOutOpen={isLogOutOpen}
        setIsLogoutOpen={setIsLogoutOpen}
      />
    </UserMenuContainer>
  );
};
